webpackJsonp([35783957827783],{

/***/ 291:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 127:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/laboratory.d9025d2f.jpg";

/***/ }),

/***/ 129:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/showroom.58b58b32.jpg";

/***/ }),

/***/ 202:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(63);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	__webpack_require__(291);
	
	var _logo = __webpack_require__(74);
	
	var _logo2 = _interopRequireDefault(_logo);
	
	var _github = __webpack_require__(72);
	
	var _github2 = _interopRequireDefault(_github);
	
	var _linkedin = __webpack_require__(73);
	
	var _linkedin2 = _interopRequireDefault(_linkedin);
	
	var _medium = __webpack_require__(75);
	
	var _medium2 = _interopRequireDefault(_medium);
	
	var _showroom = __webpack_require__(129);
	
	var _showroom2 = _interopRequireDefault(_showroom);
	
	var _laboratory = __webpack_require__(127);
	
	var _laboratory2 = _interopRequireDefault(_laboratory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	if (typeof window !== 'undefined') {
	  __webpack_require__(71)('a[href*="#"]');
	}
	
	exports.default = function () {
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      "div",
	      { className: "nav" },
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: "/" },
	        _react2.default.createElement("img", { src: _logo2.default, alt: "Marco Peixeiro logo" })
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "links" },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          {
	            className: "navlink",
	            to: "/showroom" },
	          "Showroom"
	        ),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          {
	            className: "navlink",
	            to: "/laboratory" },
	          "Laboratory"
	        ),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          {
	            className: "navlink",
	            to: "/blog" },
	          "Blog"
	        ),
	        _react2.default.createElement(
	          "a",
	          { "data-scroll": true, href: "#contact", className: "lastnavlink" },
	          "Contact"
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "hero" },
	      _react2.default.createElement(
	        "div",
	        { className: "hero-content" },
	        _react2.default.createElement(
	          "h1",
	          null,
	          "Creative"
	        ),
	        _react2.default.createElement(
	          "h1",
	          null,
	          "Data Scientist"
	        ),
	        _react2.default.createElement(
	          "h1",
	          null,
	          "Software Engineer"
	        ),
	        _react2.default.createElement(
	          "a",
	          { "data-scroll": true, href: "#about", className: "button" },
	          "Learn more"
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { id: "about", className: "about" },
	      _react2.default.createElement(
	        "h1",
	        null,
	        "I code. I create. I learn."
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "My coding journey started in web development. I quickly moved on to learn full-stack development before diving into data science. An engineer at heart, I tinker with design to bring my projects to a higher level."
	      ),
	      _react2.default.createElement(
	        "a",
	        { "data-scroll": true, href: "#showroom", className: "button" },
	        "See what I can do"
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { id: "showroom", className: "showroom" },
	      _react2.default.createElement("img", { src: _showroom2.default }),
	      _react2.default.createElement(
	        "div",
	        { className: "text" },
	        _react2.default.createElement(
	          "h1",
	          null,
	          "Showroom"
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "Explore my collection of web projects."
	        ),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: "/showroom", className: "visit" },
	          "Visit the showroom"
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "laboratory" },
	      _react2.default.createElement(
	        "div",
	        { className: "text" },
	        _react2.default.createElement(
	          "h1",
	          null,
	          "Laboratory"
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "Find more about my data science and AI projects."
	        ),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: "/laboratory", className: "visit" },
	          "Visit the laboratory"
	        )
	      ),
	      _react2.default.createElement("img", { src: _laboratory2.default })
	    ),
	    _react2.default.createElement(
	      "div",
	      { id: "contact", className: "contact" },
	      _react2.default.createElement(
	        "h1",
	        null,
	        "Let's work together"
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "form" },
	        _react2.default.createElement(
	          "form",
	          { name: "contact", method: "POST", "data-netlify": "true" },
	          _react2.default.createElement(
	            "label",
	            { "for": "name" },
	            "Name"
	          ),
	          _react2.default.createElement("input", { type: "text", id: "name", name: "name" }),
	          _react2.default.createElement(
	            "label",
	            { "for": "email" },
	            "Email Address"
	          ),
	          _react2.default.createElement("input", { type: "email", id: "email", name: "email" }),
	          _react2.default.createElement(
	            "label",
	            { "for": "message" },
	            "Message"
	          ),
	          _react2.default.createElement("textarea", { id: "message", name: "message" }),
	          _react2.default.createElement(
	            "button",
	            { type: "submit", className: "button" },
	            "Send"
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "footer",
	      null,
	      _react2.default.createElement(
	        "div",
	        { className: "icons" },
	        _react2.default.createElement(
	          "a",
	          { href: "https://github.com/marcopeix", target: "_blank" },
	          _react2.default.createElement("img", { src: _github2.default })
	        ),
	        _react2.default.createElement(
	          "a",
	          { href: "https://medium.com/me/stories/public", target: "_blank" },
	          _react2.default.createElement("img", { src: _medium2.default })
	        ),
	        _react2.default.createElement(
	          "a",
	          { href: "https://www.linkedin.com/in/marco-peixeiro/", target: "_blank" },
	          _react2.default.createElement("img", { className: "last", src: _linkedin2.default })
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "links" },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          {
	            className: "navlink",
	            to: "/showroom" },
	          "Showroom"
	        ),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          {
	            className: "navlink",
	            to: "/laboratory" },
	          "Laboratory"
	        ),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          {
	            className: "navlink",
	            to: "/blog" },
	          "Blog"
	        ),
	        _react2.default.createElement(
	          "a",
	          { "data-scroll": true, href: "#contact", className: "lastnavlink" },
	          "Contact"
	        )
	      )
	    )
	  );
	};
	
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-29ccb7bf5b9055b5e56b.js